export default "__VITE_ASSET__y4nDNNZX__"